import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import BankAccount from '../../entities/bankAccount';
import Transaction from '../../entities/transaction';
import Invoice from '../../entities/invoice';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteBankAccount(): boolean {
return true;
}
export function collectBankAccountDeleteImpact(bankAccount: BankAccount, context: DeleteImpactContext): void {
const key = 'bankAccount:' + bankAccount.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
const transactionSourceTypeImpact = workingRows<Transaction>('transaction', findAll<Transaction>('transactions')).filter(transactionRef => transactionRef.sourceType === 'B' && transactionRef.source === bankAccount.id && transactionRef.status !== 'D');
transactionSourceTypeImpact.forEach(transaction => addDeleteImpact(context, 'transaction:' + transaction.id, 'transactions'));
const transactionTargetTypeImpact = workingRows<Transaction>('transaction', findAll<Transaction>('transactions')).filter(transactionRef => transactionRef.targetType === 'B' && transactionRef.target === bankAccount.id && transactionRef.status !== 'D');
transactionTargetTypeImpact.forEach(transaction => addDeleteImpact(context, 'transaction:' + transaction.id, 'transactions'));}
export function deleteImpactBankAccount(bankAccount: BankAccount): DeleteImpact {
const context = deleteImpactContext();
collectBankAccountDeleteImpact(bankAccount, context);
return deleteImpactCounts(context);
}
export function deleteBankAccount(bankAccount: BankAccount, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteBankAccount()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectBankAccountDeleteImpact(bankAccount, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || bankAccount.id};
}
const key = 'bankAccount:' + bankAccount.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));
workingRows<Transaction>('transaction', findAll<Transaction>('transactions')).filter(transactionTemp => transactionTemp.sourceType === 'B' && transactionTemp.source === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
if (_transaction.status === 'D') return;
if (findAll<Invoice>('invoices').filter(invoice => invoice.invoiceStatus === 'F' && (invoice.transactionIds?.includes(_transaction.id) || invoice.id === _transaction.invoiceId)).length > 0) return;
_transaction.source = null;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction), 'transaction:' + _transaction.id);
});
workingRows<Transaction>('transaction', findAll<Transaction>('transactions')).filter(transactionTemp => transactionTemp.targetType === 'B' && transactionTemp.target === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
if (_transaction.status === 'D') return;
if (findAll<Invoice>('invoices').filter(invoice => invoice.invoiceStatus === 'F' && (invoice.transactionIds?.includes(_transaction.id) || invoice.id === _transaction.invoiceId)).length > 0) return;
_transaction.target = null;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction), 'transaction:' + _transaction.id);
});
const deleted = bankAccount.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.BankAccountActions.removeBankAccountQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}

export function replaceBankAccount(bankAccount: BankAccount, replaceWith: BankAccount, mergeId?: string) {
let targetImportSource = 'merge';
if (!mergeId) {targetImportSource = 'delete';mergeId = bankAccount.id;}
const _work = workingSet();

workingRows<Transaction>('transaction', findAll<Transaction>('transactions')).filter(transactionTemp => transactionTemp.sourceType === 'B' && transactionTemp.source === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
if (_transaction.status === 'D') return;
if (findAll<Invoice>('invoices').filter(invoice => invoice.invoiceStatus === 'F' && (invoice.transactionIds?.includes(_transaction.id) || invoice.id === _transaction.invoiceId)).length > 0) return;
_transaction.source = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});
workingRows<Transaction>('transaction', findAll<Transaction>('transactions')).filter(transactionTemp => transactionTemp.targetType === 'B' && transactionTemp.target === bankAccount.id && transactionTemp.status !== 'D').forEach(transactionTemp => {
const _transaction = ((_work.get('transaction:' + transactionTemp.id) ?? transactionTemp) as Transaction).clone();
if (_transaction.status === 'D') return;
if (findAll<Invoice>('invoices').filter(invoice => invoice.invoiceStatus === 'F' && (invoice.transactionIds?.includes(_transaction.id) || invoice.id === _transaction.invoiceId)).length > 0) return;
_transaction.target = replaceWith.id;
_transaction.status = 'U';
_transaction.addedOn = newHRTimestamp();
_transaction.addedBy = getCurrentUserId();
_transaction.importSource = targetImportSource;
_transaction.importId = mergeId;
_work.set('transaction:' + _transaction.id, _transaction);
store.dispatch(Actions.TransactionActions.saveTransactionQueue(_transaction));
});


return bankAccount;
}
